import { createSlice } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";

const initialState = {
  setMenuItemsList: [],
  userInfoList: [],
  companyFormList: [],
  countryFormList: [],
  storeFormList: [],
  rankList: [],
  loggedUser: {},
  userInfoExp: {},
  validToken: false,
  loading: false,
  error: undefined,
  token: null,
};

const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    setMenuItemsList(state, action) {
      state.setMenuItemsList = action.payload;
      state.loading = false;
    },
    fetchUserInfoExp(state, action) {
      state.userInfoExp = action.payload;
      state.loading = false;
    },
    fetchCompanyFormList(state, action) {
      state.companyFormList = action.payload;
      state.loading = false;
    },
    fetchCountryFormList(state, action) {
      state.countryFormList = action.payload;
      state.loading = false;
    },
    fetchStoreFormList(state, action) {
      state.storeFormList = action.payload;
      state.loading = false;
    },
    fetchRankList(state, action) {
      state.rankList = action.payload;
      state.loading = false;
    },
    fetchUserInfo(state, action) {
      state.userInfoList = action.payload;
      state.loading = false;
    },
    setCurrentUser(state, action) {
      state.validUser = !isEmpty(action.payload);
      state.loggedUser = action.payload;
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const securityActions = securitySlice.actions;

export default securitySlice.reducer;
